import { fetchApi } from "./api";
import { API_ENDPOINTS } from "../config/api";
import type {
  VariantOverride,
  OverrideListParams,
  CreateOverrideRequest,
  UpdateOverrideRequest,
  OverrideApplyResponse,
} from "../types/overrides";

export async function listOverrides(
  params: OverrideListParams = {},
): Promise<VariantOverride[]> {
  const search = new URLSearchParams();
  if (params.source) search.set("source", params.source);
  if (params.is_active !== undefined)
    search.set("is_active", String(params.is_active));
  if (params.limit != null) search.set("limit", String(params.limit));
  if (params.offset != null) search.set("offset", String(params.offset));
  const query = search.toString();
  const url = query
    ? `${API_ENDPOINTS.variantOverrides}?${query}`
    : API_ENDPOINTS.variantOverrides;
  return fetchApi<VariantOverride[]>(url);
}

export async function createOverride(
  body: CreateOverrideRequest,
): Promise<VariantOverride> {
  return fetchApi<VariantOverride>(API_ENDPOINTS.variantOverrides, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateOverride(
  id: number,
  body: UpdateOverrideRequest,
): Promise<VariantOverride> {
  return fetchApi<VariantOverride>(API_ENDPOINTS.variantOverride(id), {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function deleteOverride(id: number): Promise<void> {
  return fetchApi<void>(API_ENDPOINTS.variantOverride(id), {
    method: "DELETE",
  });
}

export async function applyOverride(
  id: number,
  dryRun: boolean,
): Promise<OverrideApplyResponse> {
  const search = new URLSearchParams();
  search.set("dry_run", String(dryRun));
  return fetchApi<OverrideApplyResponse>(
    `${API_ENDPOINTS.variantOverrideApply(id)}?${search}`,
    { method: "POST" },
  );
}
